import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=b2488406&lang=pug&"
import script from "./Contracts.vue?vue&type=script&lang=ts&"
export * from "./Contracts.vue?vue&type=script&lang=ts&"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=b2488406&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports